import { Container } from "@mui/material";
import React from "react";
import { FaUsers, FaBriefcase, FaAward, FaCheckCircle } from "react-icons/fa";
import travel1 from "../../../../assets/images/tr2.jpg";
import travel2 from "../../../../assets/images/tr1.jpg";
import travel3 from "../../../../assets/images/tr3.jpg";
import SectionHeader from "../../../../components/typography/SectionHeader";

const StatBox = ({ icon: Icon, number, text }) => (
  <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow">
    <Icon className="w-8 h-8 text-blue-400 mb-3" />
    <h3 className="text-3xl font-bold text-gray-900 mb-1">{number}</h3>
    <p className="text-gray-600 text-center">{text}</p>
  </div>
);

const AboutSection = () => {
  const stats = [
    {
      icon: FaUsers,
      number: "15K+",
      text: "Happy Customers",
    },
    {
      icon: FaBriefcase,
      number: "250+",
      text: "Tour Packages",
    },
    {
      icon: FaAward,
      number: "10+",
      text: "Years Experience",
    },
    {
      icon: FaCheckCircle,
      number: "650+",
      text: "Destinations",
    },
  ];

  return (
    <Container>
      <div className="">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={travel1}
                alt="Travel Experience 1"
                className="rounded-lg w-full h-[400px] object-cover"
              />
              <div className="space-y-4 mt-8">
                <img
                  src={travel2}
                  alt="Travel Experience 2"
                  className="rounded-lg w-full h-[180px] object-cover"
                />
                <img
                  src={travel3}
                  alt="Travel Experience 3"
                  className="rounded-lg w-full h-[180px] object-cover"
                />
              </div>
              {/* Experience Badge */}
              <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-8 py-4 rounded-lg shadow-xl">
                <p className="text-2xl font-bold">10+ Years</p>
                <p className="text-sm">of Experience</p>
              </div>
            </div>
          </div>

          {/* Right side - Content */}
          <div>
            <div className="mb-8 flex flex-col gap-2">
              <SectionHeader tagline="ABOUT US" title="WHO WE ARE" />

              <p className="text-gray-600 mb-6">
                We specialise in guiding students on their journey to
                prestigious institutions globally. Our expert counsellors offer
                personalised guidance, streamlining the study abroad process.
                Through our partnerships with global institutions, we are
                equipped to aid you in selecting and enrolling at the college or
                university of your preference anywhere in the world, within your
                desired field of study.
              </p>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <FaCheckCircle className="w-5 h-5 text-blue-400" />
                  <span className="text-gray-700">Global Expertise</span>
                </div>
                <div className="flex items-center gap-3">
                  <FaCheckCircle className="w-5 h-5 text-blue-400" />
                  <span className="text-gray-700">Personalized Guidance</span>
                </div>
                <div className="flex items-center gap-3">
                  <FaCheckCircle className="w-5 h-5 text-blue-400" />
                  <span className="text-gray-700">Proven Expertise</span>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a href="#services">
              <button className="bg-primary text-white px-8 py-3 rounded-full shadow-lg hover:bg-blue-700 hover:shadow-2xl transition-colors mb-12">
                Discover More
              </button>
            </a>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => (
                <StatBox
                  key={index}
                  icon={stat.icon}
                  number={stat.number}
                  text={stat.text}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AboutSection;
